import React from 'react';
import Svg from './Svg';
import Theme from '../../styles/theme';
import StyleDecorator from '../StyleDecorator';

const AttentionIcon = (props) => {
	const style = {
		attentionIcon: {
			fill: props.color,
		},
		exclamationMark: {
			fill: props.exclamationMarkColor,
		},
	};

	/*eslint-disable */
	return (
		<Svg
			containerStyle={props.style}
			color={props.color}
			svgStyle={style.attentionIcon}
		>
			<path d="M1.8,23.4L12.1,3.2c1.3-2.4,4.3-2.4,5.7,0l10.3,20.2c1.5,3.1-0.6,5.2-3.3,5.2H5C2.5,28.6,0.4,26.9,1.8,23.4z"/>
			<g style={style.exclamationMark}>
				<path d="M15,20.2L15,20.2c-0.8,0-1.4-0.6-1.4-1.4L13.1,10V9.8c0-1,0.8-1.9,1.9-1.9s1.9,0.8,1.9,1.9l-0.5,9.1
    C16.3,19.6,15.7,20.2,15,20.2z"/>
				<circle cx="15" cy="23.4" r="1.5"/>
			</g>
		</Svg>
	);
	/*eslint-enable */
};

AttentionIcon.propTypes = {
	style: React.PropTypes.object,
	color: React.PropTypes.string.isRequired,
	exclamationMarkColor: React.PropTypes.string,
};

AttentionIcon.defaultProps = {
	style: {},
	exclamationMarkColor: Theme.palette.primary2Color,
};

export default StyleDecorator(AttentionIcon);



// WEBPACK FOOTER //
// ./src/components/images/AttentionIcon.js